<template>
  <b-container class="p-0" fluid>
    <navigation-bar class="error-nav" :back="true" :appClose="isMobile" />
    <div class="login-error-oidc-body">
      <div class="logo-box">
        <icon-navigation-brand class="logo-box-body" />
      </div>

      <div class="text-left oidc-error-message">
        <p>{{ appName }}の利用が制限されています。</p>
        <p>所属するアカウント管理グループの管理者にご連絡ください。</p>
      </div>

      <div class="text-left error-info">
        <div>Error : {{ loginRestrictMessage }}</div>
        <div>Description : {{ loginRestrictDesc }}</div>
      </div>
    </div>
  </b-container>
</template>
<style scoped lang="scss">
.error-nav {
  @media screen and (min-width: 768px) {
    display: none;
  }
}

.login-error-oidc-body {
  height: calc(100vh - 50px - 2rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  color: #7d9ea5;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  word-break: break-all;
  vertical-align: baseline;

  .logo-box {
    box-sizing: border-box;
    padding: 20px;
    .logo-box-body {
      height: 36px;
    }
  }

  .oidc-error-message {
    max-width: 80%;
    > p {
      margin: 0px;
    }
  }

  .error-info {
    margin-top: 40px;
    max-width: 80%;
  }
}
</style>
<script lang="ts">
import { computed, defineComponent, getCurrentInstance, ref } from "vue";
import type Vue from "vue";
import { useAppStore } from "@/store";
import IconNavigationBrand from "../components/icon/IconNavigatonBrand.vue";
import NavigationBar from "../components/NavigationBar.vue";

export default defineComponent({
  name: "login-error-oidc",
  components: { IconNavigationBrand, NavigationBar },
  setup() {
    // $route は vue-router が生やす（Step 3 で composable 化予定）
    const vm = getCurrentInstance()?.proxy as Vue | undefined;

    const appName = ref<string>("掲示板");

    const loginErrorOidcRestrict = ref<boolean>(false);

    const loginRestrictMessage = computed((): string => {
      return (vm?.$route.query?.message || "unauthorized_client") as string;
    });

    const loginRestrictDesc = computed((): string => {
      return (vm?.$route.query?.desc || "") as string;
    });

    const isMobile = computed((): boolean => {
      const isMobile = useAppStore().isMobile as boolean;
      return isMobile;
    });

    return {
      appName,
      loginErrorOidcRestrict,
      loginRestrictMessage,
      loginRestrictDesc,
      isMobile,
    };
  },
});
</script>
